import { compose } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText, withAppNowUtc } from '@mews/framework';
import { withBreakpointRange } from '@optimus-web/core';
import { changePage } from '../pagination/actions';
import { getSelectedPageIds, getSelectedPage, getTotalSize } from '../pagination/selectors';
import EntityTitle from '../../components/commander-ui/EntityTitle';
import { isAdding, isEditing, isFetching, isDeleting } from './selectors';
import {
    startEntityAdding,
    stopEntityEditing,
    startEntityEditing,
    destroyEntityScope,
    stopEntityAdding,
    stopEntityDeleting,
    destroyScope,
} from './actions';

interface DeleteStateProps {
    entityName: string;
    opened: boolean;
    deleting: boolean;
}

interface DeleteDispatchProps {
    onCancel: () => void;
    onConfirmation: () => void;
}

export const connectPagedEntityManager = connect(undefined, (dispatch, { scope }: { scope: string }) => ({
    onAdd: () => dispatch(startEntityAdding(scope)),
    onUnmount: () => {
        dispatch(destroyScope(scope));
        dispatch(destroyEntityScope(scope));
    },
}));

// @ts-expect-error $TSFixMeError: Parameter 'entitiesSelector' implicitly has an 'any' type.
export const createPagedEntityTableConnect = (entitiesSelector) =>
    compose(
        withAppNowUtc,
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        connect(
            // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type 'AppNowUtcProps & { children?: ReactNode; }'.
            (state, { scope, ownerId, accountId, appNowUtc }) => {
                const ids = getSelectedPageIds(state, { scope });
                return {
                    source: entitiesSelector(state, { ids, ownerId, accountId, appNowUtc }),
                    selected: getSelectedPage(state, { scope }),
                    size: getTotalSize(state, { scope }),
                };
            },
            // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type 'AppNowUtcProps & { children?: ReactNode; }'.
            (dispatch, { scope }) => ({
                // @ts-expect-error $TSFixMeError: Parameter 'id' implicitly has an 'any' type.
                onEdit: (id) => dispatch(startEntityEditing(id, scope)),
                // @ts-expect-error $TSFixMeError: Parameter 'page' implicitly has an 'any' type.
                onPageChange: (page) => dispatch(changePage(page, scope)),
            })
        ),
        withBreakpointRange
    );

// @ts-expect-error $TSFixMeError: Binding element 'titleKey' implicitly has an 'any' type.
export const createAddFormConnect = ({ titleKey, addAction, submitButtonKey = TextKey.Create }) =>
    connect(
        createStructuredSelector({
            // @ts-expect-error $TSFixMeError: No overload matches this call.
            opened: isAdding,
        }),
        // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
        (dispatch, { scope, ownerId, isCompany }) => ({
            onClose: () => {
                dispatch(stopEntityAdding(scope));
            },
            // @ts-expect-error $TSFixMeError: Parameter 'values' implicitly has an 'any' type.
            onSubmit: (values) => dispatch(addAction(values, ownerId, scope, isCompany)),
        }),
        (stateProps, dispatchProps, ownProps) => ({
            ...stateProps,
            ...dispatchProps,
            ...ownProps,
            modal: true,
            title: (
                <EntityTitle>
                    <LocalizedText textKey={titleKey} />
                </EntityTitle>
            ),
            submitButtonProps: {
                label: <LocalizedText textKey={submitButtonKey} />,
            },
        })
    );

// @ts-expect-error $TSFixMeError: Binding element 'titleKey' implicitly has an 'any' type.
export const createEditFormConnect = ({ titleKey, editAction }) =>
    connect(
        createStructuredSelector({
            // @ts-expect-error $TSFixMeError: No overload matches this call.
            opened: isEditing,
        }),
        // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
        (dispatch, { scope, ownerId }) => ({
            onClose: () => {
                dispatch(stopEntityEditing(scope));
            },
            // @ts-expect-error $TSFixMeError: Parameter 'values' implicitly has an 'any' type.
            onSubmit: (values) => dispatch(editAction(values, ownerId, scope)),
        }),
        (stateProps, dispatchProps, ownProps) => ({
            ...stateProps,
            ...dispatchProps,
            ...ownProps,
            modal: true,
            title: (
                <EntityTitle>
                    <LocalizedText textKey={titleKey} />
                </EntityTitle>
            ),
            submitButtonProps: {
                label: <LocalizedText textKey={TextKey.Save} />,
            },
        })
    );

// @ts-expect-error $TSFixMeError: Parameter 'nameSelector' implicitly has an 'any' type.
export const createDeleteDialogConnect = (nameSelector, deleteAction) =>
    connect<DeleteStateProps, DeleteDispatchProps>(
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        createStructuredSelector({
            entityName: nameSelector,
            opened: isDeleting,
            deleting: isFetching,
        }),
        // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
        (dispatch, { scope, ownerId, isCompany }) => ({
            onCancel: () => dispatch(stopEntityDeleting(scope)),
            onConfirmation: () => dispatch(deleteAction(ownerId, scope, isCompany)),
        })
    );
